import React from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import SettingsApplicationsOutlinedIcon from "@mui/icons-material/SettingsApplicationsOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import useQueryParams from "src/hooks/useQueryParams";
import { useProject } from "src/contexts/project";

import FieldsModal from "./FieldsModal";

export default function Fields({
  type,
  initialValues,
  reorderFields,
  onChangeOrder,
  onSubmit,
  useProjectSettingsModel = false,
}) {
  const { projectId } = useParams();
  const currentProject = useProject();
  const storageEnabled = currentProject?.storageEnabled;
  const onsiteCapture = currentProject?.settings?.onsite_inventory_capture;
  const showFieldsButton =
    Boolean(projectId) && (!storageEnabled || Boolean(onsiteCapture));
  const location = useLocation();
  const navigate = useNavigate();
  const params = useQueryParams();
  const open = params.get("project_fields") === "true";

  const handleToggle = () => {
    const nextParams = new URLSearchParams(location.search);
    if (open) {
      nextParams.delete("project_fields");
    } else {
      nextParams.set("project_fields", "true");
    }
    navigate({ pathname: location.pathname, search: nextParams.toString() });
  };

  return (
    <>
      {showFieldsButton && (
        <>
          <Button size="small" onClick={handleToggle}>
            <SettingsApplicationsOutlinedIcon fontSize="small" sx={{ color: "#546e7a" }} />
            <Box mr={1} />
            <Typography color="text.secondary" variant="body2" sx={{ textTransform: "none" }}>
              Fields
            </Typography>
          </Button>
          {open && (
            <FieldsModal
              type={type}
              initialValues={initialValues}
              onToggle={handleToggle}
              onSubmit={onSubmit}
              reorderFields={reorderFields}
              onChangeOrder={onChangeOrder}
              useProjectSettingsModel={useProjectSettingsModel}
            />
          )}
        </>
      )}
    </>
  );
}
